export default [
  {
    path: '',
    name: 'writer',
    component: () => import(/* webpackChunkName: "home" */ '../views/writer/Home.vue')
  },
  {
    path: 'orders',
    component: () => import(/* webpackChunkName: "orders" */ '../views/writer/Orders.vue'),
    children: [
      {
        path: '',
        name: 'writer.orders',
        component: () => import(/* webpackChunkName: "orders" */ '../views/writer/orders/Index.vue')
      },
      {
        path: ':id',
        name: 'writer.orders.show',
        component: () => import(/* webpackChunkName: "orders.show" */ '../views/writer/orders/Show.vue')
      },
    ]
  },
  {
    path: 'notifications',
    name: 'writer.notifications',
    component: () => import(/* webpackChunkName: "notifications" */ '../views/dashboard/Notifications.vue')
  },
  {
    path: 'messages',
    component: () => import(/* webpackChunkName: "messages" */ '../views/dashboard/Messages.vue'),
    children: [
      {
        path: '',
        name: 'writer.messages',
        component: () => import(/* webpackChunkName: "messages" */ '../views/dashboard/messages/Index.vue')
      },
      {
        path: ':id',
        name: 'writer.messages.show',
        component: () => import(/* webpackChunkName: "messages.show" */ '../views/dashboard/messages/Show.vue')
      },
    ]
  },
  {
    path: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/dashboard/Profile.vue'),
    children: [
      {
        path: '',
        name: 'writer.profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/dashboard/profile/Index.vue')
      },
    ]
  },
]